import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AnalyzerConfiguration } from 'src/app/models/analyzerConfiguration';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { Organization } from 'src/app/models/organization';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-edit-analyzer-configuration-dialog',
  templateUrl: './edit-analyzer-configuration-dialog.component.html',
  styleUrl: './edit-analyzer-configuration-dialog.component.scss'
})
export class EditAnalyzerConfigurationDialogComponent {

  analyzerConfiguration?: AnalyzerConfiguration;

  defaultAnalyzerConfiguration: AnalyzerConfiguration = {
    thresholds: {
      logoDetection: 0.5,
      logoDetectionImage: 0.3,
      imageSimilarity: 0.8,
      textSimilarity: 0.6,
      psSimilarity: 0.8
    },
    defaultValues: {
      countryGuessedFromLang: 0.5,
      countryGuessedFromLangEN: 0.2,
      otherDocumentClass: 0.1
    },
    organizationId: "none"
  };
  organization?: Organization;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<EditAnalyzerConfigurationDialogComponent>,
    private translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    if (this.data && this.data.analyzerConfiguration) {
      this.analyzerConfiguration = this.data.analyzerConfiguration;
      this.organization; this.data.organization;
    }

  }

  ngOnDestroy(): void {
  }

  resetToDefaultValues() {
    this.analyzerConfiguration = this.defaultAnalyzerConfiguration;
  }


  onCancel(): void {
    this.dialogRef.close({
      edited: false
    });
  }

  async onSave() {


    const config: MatDialogConfig = {
      panelClass: 'dialog-container',
      width: '480px',
      data: {
        title: 'ORGANIZATION.ANALYZER_CONFIGURATION.EDIT_CONFIGURATION',
        text: this.translate.instant('ORGANIZATION.ANALYZER_CONFIGURATION.EDIT_CONFIGURATION_CONFIRM', this.organization),
        button: {
          text: 'ACTIONS.CONFIRM',
          class: 'main-button'
        }
      }
    }
    const dialog = this.dialog.open(ConfirmationDialogComponent, config);
    const result: { confirmed: boolean } = await firstValueFrom(dialog.afterClosed());
    if (result && result.confirmed) {
      this.dialogRef.close({
        edited: true,
        analyzerConfiguration: this.analyzerConfiguration
      });



    }
  }
}
